import React from "react";
import { useFormContext } from "react-hook-form";
import ObservationsAction from "@common/redux/actions/ObservationsAction";
import MultiSelectComponent from "@common/components/shared/forms/MultiSelectComponent";
import SelectComponent from "@common/components/shared/forms/SelectComponent";
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import { useSelector } from "react-redux";

const ObservationsSelectForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { observationOptions, moodOptions } = useSelector((state) =>
    ObservationsAction.getStatePath(state),
  );
  const observation = watch("observation");

  return (
    <>
      <SelectComponent
        name="observation"
        label="Observation"
        placeholder="Select an observation ..."
        control={control}
        error={errors.observation}
        options={observationOptions}
        labelStyle="w-40"
      />
      <MultiSelectComponent
        name="customerMood"
        label="Customer Mood"
        placeholder="Select all that apply ..."
        control={control}
        error={errors.customerMood}
        options={moodOptions}
        labelStyle="w-40"
      />
      {observation === 10 && (
        <TextareaComponent
          name="comments"
          label="Comments"
          placeholder="Please enter comments..."
          register={register}
          fieldStyle="py-1"
          error={errors.comments}
        />
      )}
    </>
  );
};

export default ObservationsSelectForm;
